import { FAQPage } from "schema-dts"
import { createLdJsonSchemaId } from "src/seo/linkedDataHelpers"
import { textToId } from "src/utilities/url"

// https://developers.google.com/search/docs/appearance/structured-data/faqpage
export function createFaqLd({ question, answer }: { question: string; answer: string }) {
  const id = textToId(question)

  const ld: FAQPage = {
    // https://schema.org/FAQPage
    "@type": "FAQPage",
    "@id": createLdJsonSchemaId("FAQPage"),
    mainEntity: [
      {
        // https://schema.org/Question
        "@type": "Question",
        "@id": createLdJsonSchemaId("Question-" + id),
        name: question,
        acceptedAnswer: {
          // https://schema.org/Answer
          "@type": "Answer",
          "@id": createLdJsonSchemaId("Answer-" + id),
          text: answer,
        },
      },
    ],
  }

  return ld
}
